import {
  createParamSelector,
  getUseQueryResultData,
  selectUomsAndTransform,
  toUnitOfMeasureType,
  UnitOfMeasure,
  UnitOfMeasureSelectorProps,
  useGetAllUnitOfMeasuresQuery
} from "@ots-frontend/ots-data";
import {BaseUnitOfMeasureSelect, BaseUnitOfMeasureSelectProps} from "./BaseUnitOfMeasureSelect";
import {useMemo} from "react";
import {createSelector} from "@reduxjs/toolkit";

export type UnitOfMeasureSelectProps = Omit<BaseUnitOfMeasureSelectProps, "entities" | "loading"> & {
  selector?: UnitOfMeasureSelectorProps
}

const getTypeCodeArrayParam = createParamSelector<UnitOfMeasureSelectorProps | undefined, string | undefined>(params => params?.types?.map(v => v.code)?.join(","));

export const UnitOfMeasureSelect = (props: UnitOfMeasureSelectProps) => {
  const {selector, ...rest} = props;

  const selectUoms = useMemo(() => {
    return createSelector(
      [getUseQueryResultData<UnitOfMeasure[]>, getTypeCodeArrayParam],
      (data, typeCodeArray) => {
        return selectUomsAndTransform(data ?? [], {
          types: typeCodeArray?.split(",").map(toUnitOfMeasureType)
        });
      }
    );
  }, []);

  const {uoms, isLoading} = useGetAllUnitOfMeasuresQuery(undefined, {
    selectFromResult: (result) => ({
      uoms: selectUoms(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BaseUnitOfMeasureSelect entities={uoms} loading={isLoading} {...rest} />;
};
